import * as Constantes from '../../../shared/constants';

// Componentes
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';

//Modelos e Interfaces
import { IAlmacen } from 'src/app/interfaces/almacenes';
import { ICliente } from 'src/app/interfaces/cliente';
import { IEntrada } from 'src/app/interfaces/entrada';
import { IListaOpciones } from 'src/app/interfaces/lista-opciones';

// Servicios
import { AlmacenesService } from 'src/app/services/datos/almacenes.service';
import { AvisosService } from 'src/app/services/datos/avisos.service';
import { ClientesService } from 'src/app/services/datos/clientes.service';
import { EntradasService } from 'src/app/services/datos/entradas.service';
import { TransaccionesService } from 'src/app/services/datos/transacciones.service';
import { UsuarioService } from 'src/app/services/datos/usuario.service';
import { ModalRegularizarService } from 'src/app/services/modal-regularizar.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { CronTotalesMenuService } from 'src/app/services/cron-totales-menu.service';

// Entorno, librerias y funciones
declare var $: any;
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { environment } from 'src/environments/environment';
import FuncLib from 'src/app/providers/funcionesLib';
import { SidebarService } from 'src/app/services/sidebar.service';
import { EanLabelsService } from 'src/app/services/ean-labels.service';

@Component({
  selector: 'app-entradas-lista',
  templateUrl: './entradas-lista.component.html',
  styleUrls: ['./entradas-lista.component.scss'],
})
export class EntradasListaComponent implements OnInit {
  // Usar las constantes en el template
  Constantes = Constantes;

  // Librería de funciones
  public funcLib: FuncLib = new FuncLib();

  loading: boolean = false;
  textoDestacado: string = '';

  messages = {
    emptyMessage: `<span class="text-danger">Sin datos...</span>`,
    totalMessage: 'Total',
    selectedMessage: 'seleccionado',
  };

  public pdfDir: string = environment.pdfDir;

  public fotoDir: string = environment.fotoDir;
  public imgResized: string = localStorage.getItem('imgResized') || '/resize/';

  imagenSeleccionada: string | null = null;

  entradasList: IEntrada[] = [];
  almacenesList: IAlmacen[] = [];
  clientesList: ICliente[] = [];

  rows: any[] = [];
  temp: any[] = [];
  selected: any[] = [];
  strBuscarTodoArticulos: string = '';
  detalleOriginal: any[] = []; // Almacena el detalle original de la entrada seleccionada Para el filtrado de artículos

  // Mostrar también los artículos ubicados?
  mostrarUbicados =
    localStorage.getItem('mostrarUbicados') === 'true' ? true : false;

  columns = [];
  ColumnMode = ColumnMode;
  SelectionType = SelectionType;

  opcionesList: IListaOpciones = {};

  almSeleccionado: string = this.usuarioSrv.userdata.alm_por_defecto || '0'; // Almacén por defecto
  cliSeleccionado: string = '';

  public summaryPosition: string =
    localStorage.getItem('summaryPosition') || 'bottom';
  // public rowsLimitStr: string = localStorage.getItem('linTablas') || '10';
  public rowsLimitStr: string = '5';
  public rowsLimit: number = parseInt(this.rowsLimitStr);

  tempOriginalDetall: any;

  @ViewChild(EntradasListaComponent) table: EntradasListaComponent | any;

  constructor(
    private router: Router,
    public entradaSrv: EntradasService,
    private transacSrv: TransaccionesService,
    public almacenesSrv: AlmacenesService,
    public clientesSrv: ClientesService,
    public usuarioSrv: UsuarioService,
    public modalRegulSrv: ModalRegularizarService,
    private notificSrv: NotificacionesService,
    private avisosSrv: AvisosService,
    public cronTotalesSrv: CronTotalesMenuService,
    private sidebarSrv: SidebarService,
    public eanLabelsSrv: EanLabelsService
  ) { }

  ngOnInit(): void {
    console.log('__ngOnInit() this.mostrarUbicados', this.mostrarUbicados);

    this.cronTotalesSrv.getTotalesApi(); // Actualizar totales en el menú
    console.log('__entradaSrv.selected', this.entradaSrv.selected);

    this.sidebarSrv.expandMenu('entradas'); // Forzar el abrir menú de Entradas

    this.getListaEntradas();

    this.almacenesSrv.getLista().subscribe((respuesta) => {
      this.loading = false;
      this.almacenesList = respuesta.data;
    });

    this.clientesSrv.getLista().subscribe((resp) => {
      this.loading = false;
      this.clientesList = resp.data.filter(
        (cliente: { archivado: boolean }) => !cliente.archivado
      );
    });
  }

  getListaEntradas() {
    this.opcionesList.id_almacen = parseInt(this.almSeleccionado);
    this.opcionesList.id_cliente = parseInt(this.cliSeleccionado);
    this.opcionesList.swCompleto = 'isNull'; // Solo las entradas con artículos pendientes de ubicar
    this.loading = true;

    this.entradaSrv.getLista(this.opcionesList).subscribe((resp) => {
      this.loading = false;
      console.log('__getListaEntradas()', resp);
      this.entradasList = resp.data;

      // Seleccionar la línea de la entrada, si no hay ninguna, seleccionar la primera de la lista
      console.log(
        'this.entradaSrv.selected en getListaEntradas() ',
        this.entradaSrv.selected
      );
      console.log('this.entradasList[0]', this.entradasList[0]);

      if (this.entradaSrv.selected) {
        const index = this.entradasList.findIndex(
          (item) => item.id === this.entradaSrv.selected.id
        );
        this.selected =
          index !== -1 ? [this.entradasList[index]] : [this.entradasList[0]];
      } else {
        this.selected = [this.entradasList[0]];
      }

      // Guardar el detalle original antes de cualquier filtrado
      if (this.selected[0]?.detall) {
        this.detalleOriginal = [...this.selected[0].detall];
      }

      this.rows = this.entradasList;
      this.temp = [...this.entradasList];

      // Aplicar filtro si hay texto de búsqueda
      if (
        this.strBuscarTodoArticulos &&
        this.strBuscarTodoArticulos.trim() !== ''
      ) {
        this.buscarTodoArticulos();
      }
    });
  }

  buscarTodoArticulos() {
    if (!this.selected[0] || !this.detalleOriginal) {
      return;
    }

    const filtro = this.strBuscarTodoArticulos.toLowerCase().trim();

    this.selected[0].detall = this.detalleOriginal.filter((item) => {
      const campos = [
        item.pale?.toString().toLowerCase(),
        item.artEan?.toString().toLowerCase(),
        item.artSku?.toString().toLowerCase(),
        item.artDescripcion?.toLowerCase(),
        item.lote?.toString().toLowerCase(),
        item.cantidad?.toString(),
        item.ubicacion?.toString().toLowerCase(),
      ];
      return campos.some((campo) => campo?.includes(filtro));
    });
  }

  limpiaBuscaArticulos() {
    this.strBuscarTodoArticulos = '';
    if (this.selected[0] && this.detalleOriginal) {
      // Restaurar el detalle original
      this.selected[0].detall = [...this.detalleOriginal];
    }
  }

  // Función para resaltar el texto buscado
  resaltarTextoArticulos(value: any, textoDestacado: string): string {
    // Convertir value a string y manejar valores nulos/undefined
    const valueStr = value != null ? value.toString() : '';

    if (!textoDestacado || !valueStr) {
      return valueStr;
    }

    // Escapar caracteres especiales de regex
    const textoEscapado = textoDestacado.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    return valueStr.replace(
      new RegExp(textoEscapado, 'gi'),
      '<span class="resaltado">$&</span>'
    );
  }

  // Método para actualizar el detalle original cuando cambie la entrada seleccionada
  onEntradaSeleccionada(entrada: any) {
    this.selected = [entrada];
    if (entrada?.detall) {
      this.detalleOriginal = [...entrada.detall];
      // Limpiar búsqueda al cambiar de entrada
      this.strBuscarTodoArticulos = '';
    }
  }

  // Métodos para los totales (modificados para usar el detalle filtrado)
  getCountLineasPendientes(): number {
    if (!this.selected[0]?.detall) return 0;
    return this.selected[0].detall.filter(
      (item: any) => item.id_ubicacion == null
    ).length;
  }

  getTotalCantidad(): number {
    if (!this.selected[0]?.detall) return 0;
    return this.selected[0].detall
      .filter((item: any) => item.id_ubicacion == null)
      .reduce((total: number, item: any) => total + Number(item.cantidad), 0);
  }

  // Búscar y filtrar

  filtro(val: string, campo: string) {
    // filter our data
    const temp = this.temp.filter(function (d) {
      if (d[campo]) return d[campo].toLowerCase().indexOf(val) !== -1 || !val;
      return !val;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table = this.entradasList;
  }

  buscar(event: any, campo: string) {
    const txt = event?.target?.value?.toLowerCase() ?? '';
    this.filtro(txt, campo);
  }

  buscarTodo(event: any) {
    const txt = event?.target?.value?.toLowerCase() ?? '';
    const temp = this.temp.filter((d: any) =>
      Object.keys(d).some(
        (key: any) =>
          d[key] && d[key].toString().toLowerCase().includes(txt.toLowerCase())
      )
    );

    // Marcar el texto destacado
    this.textoDestacado = txt;

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table = this.entradasList;
  }

  rowsLimitChange() {
    this.rowsLimit = parseInt(this.rowsLimitStr); // convertir el valor a número
  }

  onAlmacenSelect(id: string) {
    this.almSeleccionado = id;
    this.getListaEntradas();
  }

  onClienteSelect(id: string) {
    this.cliSeleccionado = id;
    this.getListaEntradas();
  }

  onToggleMostrarUbicados() {
    if (this.mostrarUbicados) localStorage.setItem('mostrarUbicados', 'true');
    if (!this.mostrarUbicados) localStorage.setItem('mostrarUbicados', 'false');

    console.log('__onToggleMostrarUbicados', this.mostrarUbicados);
  }

  //  CRUD  //

  editRow(row: IEntrada) {
    this.notificSrv.aviso('info', `editar id ${row.id}`);
  }

  deleteRow(row: any) {
    Swal.fire({
      title: '¿Borrar registro de entrada?',
      icon: 'question',
      html: `Eliminar albaran <b>${row.albaran}</b>`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si',
    }).then((result) => {
      if (result.isConfirmed) {

        // 1. Generar transacciones para reflejar el borrado de la entrada
        const datos: any = {
          id_entrada: row.id,
          tipo: 2,
          username: this.usuarioSrv.userdata.username,
          autosave: 0
        };

        this.loading = true;
        this.transacSrv.TransaccionEntrada(datos).subscribe((respT) => {
          if (respT.error) {
            this.loading = false;
            this.notificSrv.aviso('error', respT.mensaje);
            return;
          }

          // 2. Proceder a eliminar el registro de entrada
          this.entradaSrv.delete(row.id).subscribe((resp) => {
            this.loading = false;
            console.log('__delete()', resp);

            if (resp.error) {
              this.notificSrv.aviso('error', resp.mensaje);
            } else {
              this.notificSrv.aviso('info', `Registro eliminado`);
              this.rows = this.rows.filter((objeto) => objeto.id !== row.id);

              this.selected = [];
              // No quedan más entradas?
              if (!this.rows.length) {
                this.entradasList = [];
              }
            }
          });
        });
      }
    });
  }


  creaTransaccion(id_entrada: number, tipo: number, isAutoSave: boolean = false) {
    const datos: any = {
      id_entrada: id_entrada,
      tipo: tipo,
      username: this.usuarioSrv.userdata.username,
      autosave: isAutoSave ? 1 : 0
    };

    this.loading = true;
    this.transacSrv.TransaccionEntrada(datos).subscribe((resp) => {
      this.loading = false;
      console.log('__TransaccionEntrada(datos)', datos);
      console.log('__TransaccionEntrada(resp)', resp);
      if (resp.error) {
        this.notificSrv.aviso('error', resp.mensaje);
        return;
      }
    });
  }




  onSelect(selected: any) {
    console.log('Select Event', selected, this.selected);
    this.entradaSrv.selected = this.selected[0];
  }

  infoClickEntrada(row: any) {
    console.log('__infoClickEntrada()', row);
    this.entradaSrv.selected = row;
  }

  editEntrada(id: number) {
    this.cronTotalesSrv.getTotalesApi(); // Actualizar totales en el menú
    this.router.navigate(['/panel/entrada_edit', id]);
  }

  canModificarEntrada(row: any): boolean {
    return row.swValidado === Constantes.SW_VALIDADO_SI && row.swEntradaDirecta !== '1';
  }

  canValidarEntrada(row: any): boolean {
    return row.swValidado === Constantes.SW_VALIDADO_NO && row.swEntradaDirecta !== '1';
  }

  // Imprimir etiqueta de los palés
  etiquetaPale(row: any) {
    Swal.fire({
      title: 'Imprimir etiquetas de palé',
      icon: 'question',
      html: `¿Quieres imprimir las etiquetas para los palés de esta entrada?`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si',
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('Imprimir etiqueta los palés ', row);

        const data = {
          entrada: row,
          id_usuario: this.usuarioSrv.userdata.id,
        };

        // this.loading = true;
        // this.RepartoSrv.pdfEtiquetaMulti(data)
        //   .subscribe(resp => {
        //     this.loading = false;
        //     console.log('__pdfEtiquetaMulti()', resp);
        //     if (resp.error) {
        //       this.notificacionesSrv.aviso('error', resp.mensaje);
        //       return
        //     }
        //     this.notificacionesSrv.aviso('success', resp.mensaje);
        //   });
      }
    });
  }

  avisarCliente(entrada: IEntrada) {
    Swal.fire({
      title: '<i class="fa-solid fa-laptop"></i> Enviar notificación',
      text: `Escribe el mensaje para ${entrada.cliNombre} referente a su entrada`,
      input: 'textarea',
      inputValue: `Referente a la entrada con albarán ${entrada.albaran}...`,
      inputPlaceholder: 'Escribe tu mensaje aquí...',
      showCancelButton: true,
      confirmButtonText: 'Enviar notificación',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      inputValidator: (value) => {
        if (!value || value.trim().length < 4) {
          return 'El mensaje debe contener al menos 4 caracteres';
        }
        return null;
      },
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        const texto = result.value.trim();
        const data = {
          id_cliente: entrada.id_cliente,
          tipo: Constantes.AVISO_TIPO_ENTRADA,
          buscar_pedido: entrada.albaran,
          mensaje: texto,
        };

        this.avisosSrv.avisoNew(data).subscribe((resp) => {
          if (resp.error) {
            this.notificSrv.aviso('error', resp.mensaje);
            return;
          }
          this.notificSrv.aviso('success', resp.mensaje);
        });
      }
    });
  }

  //  AUX //

  /**
   * Navega a la página de ubicación de palé completo
   * @param entradaId - ID de la entrada
   * @param paleId - ID del palé
   */
  ubicarPaleCompleto(entradaId: string | number, pale: string | number): void {
    const detalles = this.entradasList[0]?.detall || [];
    const tieneUbicacion = detalles.some(
      (detall) => detall.pale === pale && detall.ubicacion !== null
    );

    if (tieneUbicacion) {
      this.notificSrv.aviso(
        'warning',
        'No puedes ubicar el palé completo. Algunos artículos de este palé ya están ubicados.'
      );
      return;
    }

    const ruta = `/panel/entrada_ubicar_pale/${entradaId}/${pale}`;
    this.router.navigate([ruta]);
  }

  // Exportar a Excel
  exportToExcel(): void {
    const fileName = `entradas-${new Date().toISOString()}.xlsx`;
    const worksheet = XLSX.utils.json_to_sheet(this.rows);
    const workbook = XLSX.utils.book_new();

    // Forzar valores numéricos en las columnas Xlsx
    Object.entries(worksheet).forEach(([cell, cellObj]) => {
      if (!cell.startsWith('!') && !isNaN(cellObj.v) && cellObj.v !== '') {
        cellObj.v = Number(cellObj.v);
        cellObj.t = 'n';
      }
    });

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, fileName);
  }

  abrirPDF(entrada: IEntrada) {
    const url = this.pdfDir + '/albaranEntrada/' + entrada.pdf_albaran;
    window.open(url, '_blank');
  }

  public sumaCeldas(cells: any[]): number {
    const filteredCells = cells.filter((cell) => !!cell);
    const sum = filteredCells.reduce(
      (accumulator, currentValue) => accumulator + parseFloat(currentValue),
      0
    );
    return sum.toLocaleString('de-DE');
  }

  public nada(cells: any[]): string {
    return '';
  }



  // Modal imágen
  abrirPopupImagen(url: string) {
    console.log('__abrirPopupImagen()', url);
    if (url.includes('_noFoto')) return
    this.imagenSeleccionada = url;
  }

  cerrarPopupImagen() {
    this.imagenSeleccionada = null;
  }


}
